import styled from "styled-components";
import { FC } from "react";

import { Icon } from "../../Icon";
import { alpha } from "../../../typography";
import { SelectComponentProps } from "./types";
import { Option } from "../types";

const StyledMultiValue = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background-color: var(--color-secondary-200);
  border-radius: var(--size-border-radius-medium);
  ${alpha.primaryActive.body3};
  :not(:last-child) {
    margin-right: 8px;
  }
`;

const getValueLabel = (props: MultiValueProps) => {
  return (props.data as Option).label;
};

type MultiValueProps = SelectComponentProps["MultiValue"];

export const MultiValue: FC<MultiValueProps> = (props) => (
  <StyledMultiValue {...props.removeProps}>
    {getValueLabel(props)}
    {!props.isDisabled && (
      <Icon iconName="close" iconSize="small" variant="INACTIVE" plain />
    )}
  </StyledMultiValue>
);
